﻿window.cObjetReservationMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.dsOption = [{ text: "option", hint: "Cette réservation n'est pas visible dans l'agenda des réservations et ne provoque pas de collision" },
    { text: "Attente arrhes", hint: "Cette réservation est visible dasn l'agenda et peut provoquer des collisions" },
    { text: "Confirmé", hint: "Cette réservation est visible dasn l'agenda et peut provoquer des collisions" },
    { text: "Fermé", hint: "Cette réservation est visible dasn l'agenda et peut provoquer des collisions" },
    { text: "Annulé", hint: "Cette réservation n'est pas visible dans l'agenda des réservations et ne provoque pas de collision" }]

    this.mGetLibBase = function () { return "Réservation"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvel réservation"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (objet.data) {
            var dateDebut = this.mGetMinDateDebut()
            if (dateDebut) {
                var dateFin = this.mGetMaxDateFin()
                txt = "Réservation " + dateDebut.toDDMMAA() + "/" + dateFin.toDDMMAA() + " " + (objet.data.lib_client ? objet.data.lib_client : "")
            } else {
                txt = "Réservation (sans hébergement) " + (objet.data.lib_client ? objet.data.lib_client : "")
            }
        } else { txt = "Reservation" }
        if (option && option.callBack) {
            option.callBack(txt)
        } else {
            return txt
        }
    }
    this.mGetLib2 = function () {
        return ""
    }
    this.mGetNomFromTemplate = function (dataTemplate) {
        return objet.bddRef.getObjet("reservation", dataTemplate.id_key).mGetLib1()
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-bell-concierge'></i>");
    }

    this.mDelData = function (funcOk, option, noRestore, funcRestore, funcAlways, funcKo, defintif) {
        objet.mDelDataInterne(function () {
            objet.bddRef.mGetArray("reservation_hebergement").filter(function (dataResaHeberg) {
                return dataResaHeberg.id_reservation == objet.data.id_reservation
            }).forEach(function (dataResaHeberg) {
                if (dataResaHeberg.id_hebergement_agenda_centrale_rdv) {
                    var obj = objet.bddRef.getObjet("hebergement_agenda_centrale_rdv", dataResaHeberg.id_hebergement_agenda_centrale_rdv)
                    obj.data.id_reservation_hebergement = null
                    obj.mUpdateViaTrigger()
                }
                objet.bddRef.mDelItemData("reservation_hebergement", dataResaHeberg)
            })
            if (funcOk) funcOk()
        }, option, noRestore, funcRestore, funcAlways, funcKo, defintif)
    }

    this.mGetLstReservationHebergement = function () {
        return Me.objet.bddRef.mGetArray("reservation_hebergement").filter(function (o) { return o.id_reservation == objet.data.id_reservation })
    }

    this.mGetLstReservationCommande = function () {
        return Me.objet.bddRef.mGetArray("reservation_commande").filter(function (o) { return o.id_reservation == objet.data.id_reservation })
    }

    this.mGetLstDateCollision = function () {
        var lstResult = []
        var dat = new Date()
        dat = new Date(dat.getFullYear(), dat.getMonth(), dat.getDate(), 23, 59, 59)
        var idx = 0
        while (idx <= 730) {
            var lstReservationHebergement = Me.objet.bddRef.getObjet("reservation_hebergement").objetMetier.mGetLstReservationHebergementFromDate(dat).filter(function (dataResaHeberg) {
                var dataResa = objet.bddRef.getObjet(dataResaHeberg).objetMetier.mGetReservation()
                if (dataResa) {
                    var idStatutResa = dataResa.id_statut_resa
                    if (dataResaHeberg.id_reservation_hebergement_parent != null) {
                        return idStatutResa > 0 && idStatutResa < 3
                    } else {
                        return idStatutResa > 0 && idStatutResa < 4
                    }
                } else {
                    return false
                }
            })
            lstReservationHebergement = lstReservationHebergement.concat(Me.objet.bddRef.getObjet("hebergement_agenda_centrale_rdv").objetMetier.mGetLstHebergementAgendaCentraleRdv(dat))
            var lstHebergementId = []
            var lstHebergementIdDoublon = []
            lstReservationHebergement.forEach(function (resaHeberg) {
                if (!lstHebergementId.contains(resaHeberg.id_hebergement)) {
                    lstHebergementId.push(resaHeberg.id_hebergement)
                } else if (!lstHebergementIdDoublon.contains(resaHeberg.id_hebergement)) {
                    lstHebergementIdDoublon.push(resaHeberg.id_hebergement)
                }
            })

            if (lstHebergementIdDoublon.length > 0) {
                lstHebergementIdDoublon.forEach(function (idHebergement) {
                    var result = {
                        dat: new Date(dat),
                        id_hebergement: idHebergement,
                        lstReservationHebergement: []
                    }
                    lstReservationHebergement.forEach(function (resaHeberg) {
                        if (resaHeberg.id_hebergement == idHebergement) result.lstReservationHebergement.push(resaHeberg)
                    })
                    lstResult.push(result)
                })
            }
            dat = dat.addDays(1)
            idx += 1
        }
        return lstResult
    }

    this.mGetLstReservationFromDate = function (dat) {
        var lstReservation = []
        Me.objet.bddRef.getObjet("reservation_hebergement").objetMetier.mGetLstReservationHebergementFromDate(dat).forEach(function (resaHeberg) {
            var resa = Me.objet.bddRef.getObjet(resaHeberg).objetMetier.mGetReservation()
            if (!lstReservation.contains(resa)) lstReservation.push(resa)
        })
        return lstReservation
    }

    this.mGetResumeStatDate = function (dat) {
        result = {
            nb_adulte_arrive: 0,
            nb_enfant_arrive: 0,
            nb_adulte_depart: 0,
            nb_enfant_depart: 0,
            nb_adulte: 0,
            nb_enfant: 0
        }
        var dat = new Date(dat.getFullYear(), dat.getMonth(), dat.getDate(), 23, 55, 0)
        Me.objet.bddRef.getObjet("reservation_hebergement").objetMetier.mGetLstReservationHebergementFromDate(dat).forEach(function (resaHeberg) {
            var dataReservation = objet.bddRef.getObjet(resaHeberg).objetMetier.mGetReservation()
            if (dataReservation) {
                var idStatutResa = dataReservation.id_statut_resa
                if (idStatutResa > 0 && idStatutResa < 4) {
                    result.nb_adulte += parseInt(resaHeberg.nb_adulte)
                    result.nb_enfant += parseInt(resaHeberg.nb_enfant)
                    if (resaHeberg.date_debut.toConcatAAAAMMDD() == dat.toConcatAAAAMMDD()) {
                        result.nb_adulte_arrive += parseInt(resaHeberg.nb_adulte)
                        result.nb_enfant_arrive += parseInt(resaHeberg.nb_enfant)
                    }
                }
            }

        })
        Me.objet.bddRef.getObjet("reservation_hebergement").objetMetier.mGetLstReservationHebergementFromDate(dat).forEach(function (resaHeberg) {
            var dataReservation = objet.bddRef.getObjet(resaHeberg).objetMetier.mGetReservation()
            if (dataReservation) {
                var idStatutResa = dataReservation.id_statut_resa
                if (idStatutResa > 0 && idStatutResa < 4) {
                    if (resaHeberg.date_fin.toConcatAAAAMMDD() == dat.toConcatAAAAMMDD()) {
                        result.nb_adulte_depart += parseInt(resaHeberg.nb_adulte)
                        result.nb_enfant_depart += parseInt(resaHeberg.nb_enfant)
                    }
                }
            }
        })
        var hier = (new Date(dat)).addDays(-1)
        Me.objet.bddRef.getObjet("reservation_hebergement").objetMetier.mGetLstReservationHebergementFromDate(hier).forEach(function (resaHeberg) {
            var dataReservation = objet.bddRef.getObjet(resaHeberg).objetMetier.mGetReservation()
            if (dataReservation) {
                var idStatutResa = dataReservation.id_statut_resa
                if (idStatutResa > 0 && idStatutResa < 4) {
                    if (resaHeberg.date_fin.toConcatAAAAMMDD() == dat.toConcatAAAAMMDD()) {
                        result.nb_adulte_depart += parseInt(resaHeberg.nb_adulte)
                        result.nb_enfant_depart += parseInt(resaHeberg.nb_enfant)
                    }
                }
            }
        })
        return result
    }

    this.mGetLstHebergementAgendaCentraleRdvFromDateWarning = function (dat1, dat2) {
        var dat1 = new Date(dat1.getFullYear(), dat1.getMonth(), dat1.getDate(), 22, 0, 0)
        var lstResaHeberg = Me.objet.bddRef.getObjet("reservation_hebergement").objetMetier.mGetLstReservationHebergementFromDate(dat1, dat2)
        return lstResaHeberg.filter(function (resaHeberg) {
            var dataReservation = objet.bddRef.getObjet(resaHeberg).objetMetier.mGetReservation()
            return dataReservation.id_statut_resa == "1"
        })
    }

    this.mGetPercentOccupeChambre = function (dat1, dat2) {
        var dat1 = new Date(dat1.getFullYear(), dat1.getMonth(), dat1.getDate(), 22, 0, 0)
        var lstResaHeberg = Me.objet.bddRef.getObjet("reservation_hebergement").objetMetier.mGetLstReservationHebergementFromDate(dat1, dat2)
        var lstHebergementId = []
        var nbOccup = 0
        lstResaHeberg.forEach(function (resaHeberg) {
            var dataReservation = objet.bddRef.getObjet(resaHeberg).objetMetier.mGetReservation()
            if (dataReservation.id_statut_resa > 0 && dataReservation.id_statut_resa < 4) {
                //soit on a un dataresaheberg, soit lié à une chmabre virtuel
                if (resaHeberg.id_reservation_hebergement_parent == null ||
                    (resaHeberg.id_reservation_hebergement_parent != null && dataReservation.id_statut_resa != 3)) {
                    var objResaHeberg = Me.objet.bddRef.getObjet(resaHeberg)
                    var dataHeberg = objResaHeberg.objetMetier.mGetHebergement()
                    if (dataHeberg.date_abandon == null && dataHeberg.is_virtuel == "0") {
                        if (dat2) {
                            nbOccup += objResaHeberg.objetMetier.mGetNbJourChevauche(dat1, dat2)
                        } else {
                            nbOccup += 1
                        }
                    }
                }
            }
        })
        var nbCh = Me.objet.bddRef.mGetArray("hebergement").filter(function (o) { return o.date_abandon == null && o.is_virtuel == "0" }).length
        if (dat2) {
            const timeDiff = Math.abs(dat2.getTime() - dat1.getTime());
            const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
            nbCh *= daysDiff
        }
        console.log(dat1 + "/" + lstHebergementId.length)
        //return ((lstHebergementId.length == 0 || nbCh == 0) ? 0 : parseInt(lstHebergementId.length / nbCh * 100))
        return {
            nbOccup: nbOccup,
            nbChambre: nbCh,
            tx: ((nbOccup == 0 || nbCh == 0) ? 0 : parseInt(nbOccup / nbCh * 100))
        }
    }

    this.mGetDataReservationArrhesFirst = function () {
        return objet.bddRef.mGetArray("reservation_arrhes").filter(function (o) { return o.id_reservation == objet.data.id_reservation })[0]
    }
    this.mGetLstDataReservationArrhes = function () {
        return objet.bddRef.mGetArray("reservation_arrhes").filter(function (o) { return o.id_reservation == objet.data.id_reservation })
    }
    this.mGetLstDataReservationArrhesNonUtilise = function (funcOk) {
        objet.bddRef.mAjaxCall({
            command: "getlstarrhesnonutiliseforreservation",
            id_reservation: objet.data.id_reservation,
            async: false
        }, function (data) {
            if (!data.lst_id_resa_arrhes_dispo) data.lst_id_resa_arrhes_dispo = []
            funcOk(objet.bddRef.mGetArray("reservation_arrhes").filter(function (o) { return data.lst_id_resa_arrhes_dispo.filter(function (oo) { return oo.id_reservation_arrhes == o.id_reservation_arrhes }).length > 0 }))
            //return objet.bddRef.mGetArray("reservation_arrhes").filter(function (o) { data.lst_id_resa_arrhes_dispo.contains(o.id_reservation_arrhes) })
        })
    }
    //this.mGetTotalArrhesNonUtilise = function () {
    //    var tot = 0
    //    this.mGetLstDataReservationArrhes().filter(function (o) { return o.date_reglement != null }).filter(function (o) {
    //        tot += o.mt - o.mt_utilise
    //    })
    //    return tot
    //}

    this.hasArrhesNonRegle = function () {
        return objet.bddRef.mGetArray("reservation_arrhes").filter(function (o) {
            return o.id_reservation == objet.data.id_reservation && o.date_reglement == null
        }).length > 0
    }

    this.hasArrhesRegle = function () {
        return objet.bddRef.mGetArray("reservation_arrhes").filter(function (o) {
            return o.id_reservation == objet.data.id_reservation && o.date_reglement != null
        }).length > 0
    }

    this.hasArrhesAttenteReglement = function () {
        return objet.bddRef.mGetArray("reservation_arrhes").filter(function (o) {
            return o.id_reservation == objet.data.id_reservation && o.date_reglement == null && o.date_demande != null
        }).length > 0
    }

    this.mGetCalculMtArrhes = function () {
        var totTtc = this.mGetTotalTtc()
        var percent = objet.bddRef.paraAppli.mGetPara("hebergement_percent_arrhes")
        if (percent == 0) percent = 100
        var mtArrhes = Math.round(totTtc * percent / 100)
        return mtArrhes
    }

    this.mGetAdresseEmailDestinataire = function () {
        var adrEmail = ""
        if (objet.data.id_table_destinataire) {
            var obj = objet.bddRef.getObjet(objet.bddRef.table.mGetItem(objet.data.id_table_destinataire).nom, objet.data.id_destinataire)
            adrEmail = obj.objetMetier.mGetAdresseEmailDefaut()
        }
        return adrEmail
    }

    this.isPopupFullScreen = false
    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "750",
            height: "100%",
            maxHeight: "100%",
            position: {
                my: "right bottom",
                at: "right bottom",
                of: "body",
                //offset: { x: -50, y: -25 }
            }
        }
    }
    this.mGetDisplayInPopup = function (newValue) {
        if (typeof objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] == 'undefined') {
            objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] = true
        }
        if (typeof newValue != 'undefined') {
            objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] = newValue
            objet.bddRef.mSaveParaJsonUtilisateur();
        }
        return objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom]
    }
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentReservation({
            bddCtrl: Me.objet.bddRef,
            dataReservation: objet.data,
            dataReservationHebergement: option.dataReservationHebergement,
            optionPopup: option
        }).dxCtrlContentComNote("instance")
    }

    this.mCreateNewReservation = function (idHebergement, nbAdulte, nbEnfant, dateDebut, dateFin, internetExterne, idHebergementAgendaCentraleRdv, creeArrhes = true, idResaStatut = null, funcOk) {
        this.mCreateNewReservationHebergement(null, idHebergement, nbAdulte, nbEnfant, dateDebut, dateFin, internetExterne, idHebergementAgendaCentraleRdv, idResaStatut, function (data) {
            //on rajoute les arrhes
            if (creeArrhes && (objet.bddRef.paraAppli.mGetPara("hebergement_percent_arrhes") > 0 || internetExterne)) {
                try {
                    var mtSaveArrhes = objet.bddRef.getObjet(data.dataReservation).objetMetier.mGetCalculMtArrhes()
                    var dataResaArrhes = objet.bddRef.getObjet("reservation_arrhes").mGetNewData()
                    dataResaArrhes.id_reservation = data.dataReservation.id_reservation
                    dataResaArrhes.mt = mtSaveArrhes
                    objet.bddRef.getObjet(dataResaArrhes).mSave(function () {
                        funcOk(data)
                    })
                } catch (e) {
                    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                }
            } else { funcOk(data) }

        })
    }

    this.mCreateNewReservationHebergement = function (idReservation, idHebergement, nbAdulte, nbEnfant, dateDebut, dateFin, internetExterne, idHebergementAgendaCentraleRdv, idResaStatut = null, funcEnd) {
        var objHeberg = objet.bddRef.getObjet("hebergement", idHebergement)
        var nbNuitTot = mGetNbNuits(dateDebut, dateFin)
        var lstDatePuttc = []
        mGetLstDateBetween2Dates(dateDebut, dateFin).forEach(function (dat) {
            lstDatePuttc.push({
                dat: dat,
                puttc: objHeberg.objetMetier.mGetPrixPersonneNuit(dat, nbAdulte + nbEnfant, nbNuitTot)
            })
        })
        var confDef = objHeberg.objetMetier.mGetLstBestHebergementConfigWithAdulteEnfant(nbAdulte, nbEnfant)[0]

        objet.bddRef.mAjaxCall({
            command: "createnewreservation_hebergement",
            id_reservation: idReservation,
            id_hebergement: idHebergement,
            date_debut: dateDebut,
            date_fin: dateFin,
            nb_adulte: nbAdulte,
            nb_enfant: nbEnfant,
            lst_date_puttc: lstDatePuttc,
            nb_grand_lit: (confDef ? confDef.nb_grand_lit : 1),
            nb_petit_lit: (confDef ? confDef.nb_petit_lit : 1),
            internet_externe: (internetExterne ? "1" : "0"),
            id_hebergement_agenda_centrale_rdv: idHebergementAgendaCentraleRdv,
            id_resa_statut: idResaStatut
        }, function (data) {
            var dataReservationHebergement = Me.objet.bddRef.getObjet("reservation_hebergement", data.bddadd.reservation_hebergement[0].id_reservation_hebergement).data
            Me.objet.bddRef.triggerFunctionOnModifiedItemData("reservation_hebergement", "modif", dataReservationHebergement)
            funcEnd({
                dataReservation: objet.bddRef.getObjet("reservation", dataReservationHebergement.id_reservation).data,
                dataReservationHebergement: dataReservationHebergement
            })
        })
        //var dataResaHeberg = objet.bddRef.getObjet("reservation_hebergement").mGetNewData()
        //dataResaHeberg.id_reservation = dataReservation.id_reservation
        //dataResaHeberg.id_hebergement = idHebergement
        //dataResaHeberg.nb_adulte = nbAdulte
        //dataResaHeberg.nb_enfant = nbEnfant
        //dataResaHeberg.date_debut = dateDebut
        //dataResaHeberg.date_fin = dateFin
        //objet.bddRef.getObjet(dataResaHeberg).mSave(function (data) {
        //    option.dataReservationHebergement = dataResaHeberg
        //    mConstruit()
        //})
    }

    this.mGetNbAdulte = function () {
        var nb = 0
        this.mGetLstDataReservationHebergement().forEach(function (dataResaHeberg) {
            nb += dataResaHeberg.nb_adulte
        })
        return nb
    }
    this.mGetNbEnfant = function () {
        var nb = 0
        this.mGetLstDataReservationHebergement().forEach(function (dataResaHeberg) {
            nb += dataResaHeberg.nb_enfant
        })
        return nb
    }

    this.mGetMinDateDebut = function () {
        var minDateDebut = null
        this.mGetLstReservationHebergement().forEach(function (o) {
            if (minDateDebut) {
                if (o.date_debut < minDateDebut) minDateDebut = o.date_debut
            } else { minDateDebut = o.date_debut }
        })
        return minDateDebut
    }

    this.mGetMaxDateFin = function () {
        var maxDateFin = null
        this.mGetLstReservationHebergement().forEach(function (o) {
            if (maxDateFin) {
                if (o.date_fin > maxDateFin) maxDateFin = o.date_fin
            } else { maxDateFin = o.date_fin }
        })
        return maxDateFin
    }
    this.mGetLstJourneesService = function () {
        var lstDate = null
        this.mGetLstReservationHebergement().forEach(function (dataReservationHebergement) {
            var lstDateHeberg = objet.bddRef.getObjet(dataReservationHebergement).objetMetier.mGetLstJourneesService()
            if (!lstDate) { lstDate = lstDateHeberg }
            else {
                lstDate = [...new Map(
                    lstDate.concat(lstDateHeberg).map(d => [d.getTime(), d])
                ).values()].sort((a, b) => a - b);
            }
        })
        return lstDate
    }
    this.mGetNbJourneesService = function () {
        return this.mGetLstJourneesService().length
    }

    this.mGetLstDataReservationHebergement = function () {
        return objet.bddRef.mGetArray("reservation_hebergement").filter(function (o) {
            return o.id_reservation == objet.data.id_reservation
        })
    }

    this.mGetLstHebergementReservationCentrale = function () {
        return this.mGetLstDataReservationHebergement().filter(function (o) { return o.id_centrale_reservation != null })
    }

    //this.mGetLstDataReservationService = function () {
    //    return objet.bddRef.mGetArray("reservation_service").filter(function (o) {
    //        return o.id_reservation == objet.data.id_reservation && o.id_reservation_hebergement == null
    //    })
    //}

    //this.mGetTotalTtcService = function () {
    //    var totTtc = 0
    //    this.mGetLstDataReservationService().forEach(function (dataResaService) {
    //        totTtc += objet.bddRef.getObjet(dataResaService).objetMetier.mGetTotTtc()
    //    })
    //    return totTtc
    //}

    this.mGetTotalTtcCommande = function () {
        var totTtc = 0
        this.mGetLstReservationCommande().forEach(function (dataResaCommande) {
            totTtc += objet.bddRef.getObjet(dataResaCommande).objetMetier.mGetTotTtc()
        })
        return totTtc
    }

    this.mGetTotalTtc = function () {
        var totTtc = 0
        totTtc += this.mGetTotalTtcCommande()
        this.mGetLstDataReservationHebergement().forEach(function (dataResaHeberg) {
            totTtc += objet.bddRef.getObjet(dataResaHeberg).objetMetier.mGetTotalTtc()
        })
        return totTtc
    }

    this.mGetElementRecapitulatif = function () {
        var $Div = $("<div style='font-family:barlow condensed;max-width:470px;text-align:left;display:inline-block;'/>")

        var formatDat = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
        $("<div style='font-size:160%;font-weight:bold;line-height:1;font-variant:small-caps;padding-bottom:10px;border-bottom:" + theme.border + ";'>Récapitulatif de votre séjour " + objet.data.keyguid + "<br/>du " + formatDat(this.mGetMinDateDebut()) + " au " + formatDat(this.mGetMaxDateFin()) + "</div>").appendTo($Div)

        var lstDataResaArrhes = objet.bddRef.mGetArray("reservation_arrhes").filter(function (o) {
            return o.id_reservation == objet.data.id_reservation
        })

        if (lstDataResaArrhes.length > 0) {
            //on a des arrhes
            var attenteArrhes = false
            lstDataResaArrhes.forEach(function (dataResaArrhes) {
                if (dataResaArrhes.id_doc_cpt_mode_reglement) {
                    var objDocCptReg = objet.bddRef.getObjet("doc_cpt_mode_reglement", dataResaArrhes.id_doc_cpt_mode_reglement)
                    var dataModeReglement = objet.bddRef.getObjet("mode_reglement", objDocCptReg.data.id_mode_reglement).data
                    $("<div style='color:green;margin-top:10px;'>Vous avez réglé <b>" + parseFloat(dataResaArrhes.mt).formatDisplay() + "€</b> d'arrhes " + (dataModeReglement ? "par <b>" + dataModeReglement.nom + "</b> " : "") + "le " + objDocCptReg.data.date_reglement.toDDMMAA() + "</div>").appendTo($Div)
                } else {
                    $("<div style='color:orange;margin-top:10px;'>Votre réservation est en attente du règlement des arrhes d'un montant de <b>" + parseFloat(dataResaArrhes.mt).formatDisplay() + "€</b></div>").appendTo($Div)

                    if (objet.bddRef.paraAppli.mGetPara("hebergement_mode_reglement_arrhes").length > 0) {
                        var $DivReg = $("<div style='padding-left:20px'>").appendTo($Div)
                        $("<div>Vous pouvez régler ces arrhes par:</div>").appendTo($DivReg)
                        var ajoutAdresse = false
                        objet.bddRef.paraAppli.mGetPara("hebergement_mode_reglement_arrhes").forEach(function (idModeReg) {
                            var dataModeReg = objet.bddRef.getObjet("mode_reglement", idModeReg).data
                            switch (parseInt(idModeReg)) {
                                case 1://cb
                                    var objSociete = objet.bddRef.getObjet(objet.bddRef.mGetArray("societe")[0])
                                    if (objSociete.data.has_cle_stripe == "1") {
                                        https://xxxxx.xxxxxx.eu/nom_base/idtable/id/cb
                                        $("<div style='padding-left:50px'> &bull; Carte bancaire: <a href='" + parametre.url_appli + "/" + objet.bddRef.nom_base + "/" + objet.bddRef.getObjet(dataResaArrhes).mGetTable().id_table + "/" + dataResaArrhes.id_reservation_arrhes + "/cb' target='_blank'>Cliquer ici pour le règlement par CB</a></div>").appendTo($DivReg)
                                    }
                                    break;
                                case 2://virement
                                    var objSociete = objet.bddRef.getObjet(objet.bddRef.mGetArray("societe")[0])
                                    $("<div style='padding-left:50px'> &bull; Virement: " + objSociete.objetMetier.mGetLibHtmlVirement() + " en rappelant la référence " + objet.data.keyguid + "</div>").appendTo($DivReg)
                                    break;
                                case 3://cheque
                                    var objSociete = objet.bddRef.getObjet(objet.bddRef.mGetArray("societe")[0])
                                    $("<div style='padding-left:50px'> &bull; Chèque: à l'ordre de <b>" + objSociete.objetMetier.mGetOrdreCheque() + "</b> en rappelant la référence " + objet.data.keyguid + "</div>").appendTo($DivReg)
                                    ajoutAdresse = true
                                    break;
                                case 5: //cheque vacances
                                    $("<div style='padding-left:50px'> &bull; Chèque vacances: Envoyer le montant des arrhes en chèque vacances en rappelant la référence " + objet.data.keyguid + "</div>").appendTo($DivReg)
                                    ajoutAdresse = true
                                    break;
                            }
                        })
                        if (ajoutAdresse = true) {
                            var objSoc = objet.bddRef.getObjet(objet.bddRef.mGetArray("societe")[0])
                            var adresse = objSoc.objetMetier.mGetDataAdresse()
                            if (adresse) {
                                var $DivAdr = $("<div style=''/>").appendTo($DivReg)
                                var $DivAdr2 = $("<div><span style=''>Notre adresse: </div>").appendTo($DivAdr)
                                $("<span style='font-weight:bold;'>" + objSoc.data.nom + ", </span>").appendTo($DivAdr2)
                                var objAdr = new cAdresse(adresse)
                                objAdr.mGetAffichage1lineElement().appendTo($DivAdr2)
                            }
                        }
                    }
                    attenteArrhes = true
                }
            })
        }
        if (attenteArrhes) {
            $("<div style='color:orange'>Votre réservation est confirmée et en attente du versement des arrhes. Merci de régler les arrhes afin de la valider définitivement.</div>").appendTo($Div)
            //if (Me.objet.bddRef.paraAppli.mGetPara("hebergement_temps_attente_arrhes") > 0) {
            //    var dateEnd = (new Date()).addDays(Me.objet.bddRef.paraAppli.mGetPara("hebergement_temps_attente_arrhes"))
            //    $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>Votre réservation sera maintenue jusqu’au " + dateEnd.toDDMMAA() + " au soir. Passé ce délai, et sans réception des arrhes, celle-ci sera automatiquement annulée.</div>").appendTo($Td);
            //}
        }

        var $Table = $("<table style='width:100%;border-top:" + theme.border + ";margin-top:10px;'/>").appendTo($Div)

        var lstResaHeberg = objet.bddRef.mGetArray("reservation_hebergement").filter(function (o) {
            return o.id_reservation == objet.data.id_reservation
        })
        lstResaHeberg.forEach(function (dataResaHeberg) {
            var objResaHeberg = objet.bddRef.getObjet(dataResaHeberg)
            var $Tr = $("<tr style=''/>").appendTo($Table)
            var $Td = $("<td style='width:100%;vertical-align:top;font-weight:bold;padding:10px 5px 5px 5px;font-size:140%;'/>").appendTo($Tr).text(objResaHeberg.objetMetier.mGetHebergement().nom)
            var $Td = $("<td style='width:1px;text-align:right;white-space:nowrap;padding:10px 5px 5px 5px;'>").appendTo($Tr).html(objResaHeberg.objetMetier.mGetLibNuites())

            var $Td = $("<td style='width:1px;text-align:right;white-space:nowrap;border-left:" + theme.border + ";padding:10px 5px 5px 5px;'>").appendTo($Tr).html(parseFloat(objResaHeberg.objetMetier.mGetTotalTtc()).formatDisplay() + "€")

            var lstReservationService = objet.bddRef.mGetArray("reservation_service").filter(function (o) {
                return o.id_reservation == objet.data.id_reservation && o.id_reservation_hebergement == dataResaHeberg.id_reservation_hebergement
            })
            lstReservationService.forEach(function (dataResaService) {
                var lstGrpDateNbResaService = objet.bddRef.getObjet(dataResaService).objetMetier.mGetLstGrpDateNbReservationService()
                if (lstGrpDateNbResaService.length > 0) {
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%;vertical-align:top;padding:5px;padding-left:20px;font-weight:600;'>").appendTo($Tr)
                    $Td.text(objet.bddRef.getObjet(dataResaService).objetMetier.mGetDataArticle().nom)
                    var $Td = $("<td style='width:1px;vertical-align:top;text-align:right;white-space:nowrap;padding:5px;'>").appendTo($Tr)
                    var txt = ""
                    lstGrpDateNbResaService.forEach(function (objGrpDateNbResaService) {
                        txt += (txt.length > 0 ? "<br>" : "")
                        txt += objGrpDateNbResaService.mGetLibDetailHtmlTooltip()// + " = " + parseFloat(objGrpDateNbResaService.mGetTotTtc()).formatDisplay() + "€"
                    })
                    $Td.html(txt)
                    var $Td = $("<td style='width:1px;text-align:right;white-space:nowrap;vertical-align:bottom;padding:5px;padding-left:10px;border-left:" + theme.border + ";'>").appendTo($Tr)
                    $Td.html(parseFloat(objet.bddRef.getObjet(dataResaService).objetMetier.mGetTotTtc()).formatDisplay() + "€")
                }
            })
        })

        if (this.mGetLstReservationCommande().length > 0) {
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;padding:10px 5px 5px 5px;font-weight:bold;font-size:140%;' colspan='2'>").appendTo($Tr)
            $Td.text("Service pour l'ensemble des chambres")
            var $Td = $("<td style='width:1px;text-align:right;white-space:nowrap;vertical-align:bottom;padding:10px 5px 5px 5px;;padding-left:10px;border-left:" + theme.border + ";'>").appendTo($Tr)
            this.mGetLstReservationCommande().forEach(function (dataResaCmd) {
                var objResaCmd = objet.bddRef.getObjet(dataResaCmd)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;vertical-align:top;padding:5px;padding-left:20px;font-weight:600;'/>").appendTo($Tr)
                $Td.text(objResaCmd.objetMetier.mGetDataArticle().nom)
                var $Td = $("<td style='width:1px;vertical-align:top;text-align:right;white-space:nowrap;padding:5px;'>").appendTo($Tr)
                $Td.html(objResaCmd.objetMetier.mGetLibHtml())
                var $Td = $("<td style='width:1px;text-align:right;white-space:nowrap;vertical-align:top;padding:5px;padding-left:10px;border-left:" + theme.border + ";'/>").appendTo($Tr)
                $Td.html(parseFloat(objResaCmd.objetMetier.mGetTotTtc()).formatDisplay() + "€")
            })
        }

        if (objet.data.commentaire_destinataire && objet.data.commentaire_destinataire.length > 0) {
            $("<div/>").appendTo($Div).html("<b>Votre commentaire: </b><i>" + objet.data.commentaire_destinataire + "</i>")
        }


        var $Tr = $("<tr style='font-size:140%;font-weight:bold;'/>").appendTo($Table)
        var $Td = $("<td style='width:100%;text-align:right;padding:5px;border-top:" + theme.border + ";' colspan='2'>Total TTC:</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;text-align:right;white-space:nowrap;padding:5px;padding-left:10px;border-left:" + theme.border + ";border-top:" + theme.border + ";'>").appendTo($Tr)
        $Td.html(parseFloat(Me.mGetTotalTtc()).formatDisplay() + "€")

        $("<div style='font-family:barlow condensed;text-align:right;'/>").appendTo($Div).text("Les arrivées se font entre " + objet.bddRef.paraAppli.mGetPara("hebergement_période_arrivee_depart").arrivee[0] + "h et " + objet.bddRef.paraAppli.mGetPara("hebergement_période_arrivee_depart").arrivee[1] + "h")

        $("<div style='font-style:italic;font-size:90%;line-height:1;padding-top:30px;'/>").appendTo($Div).text(objet.bddRef.paraAppli.mGetPara("hebergement_politique_arrhes"))

        var urlCgv = objet.bddRef.getObjet(objet.bddRef.mGetArray("societe")[0]).objetMetier.mGetUrlCgv()
        if (urlCgv) {
            $("<a href='" + urlCgv + "' target='_blank'>Condition générale de vente</a>").appendTo($Div)
        }

        var totHtml = $Div.prop("outerHTML")
        //on sauvegarde le resume dans la base
        objet.bddRef.mAjaxCall({
            command: "saveresumehtmlreservation",
            id_reservation: objet.data.id_reservation,
            html: totHtml
        })

        return $Div
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        var contentMiseEnForme = contentElement
        if (contentElement.closest(".divtemplate").length > 0) {
            contentMiseEnForme = contentElement.closest(".divtemplate")
        }

        contentMiseEnForme.addClass("resa_heberg idstatutresa" + dataTemplate.id_statut_resa)
        contentElement.css("white-space", "normal")
        if (dataTemplate.id_statut_resa == 5) contentMiseEnForme.css("background-image", "repeating-linear-gradient(-45deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12) 6px, transparent 6px, transparent 12px)")

        var nbResaHeberg = objet.bddRef.mGetArray("reservation_hebergement").filter(function (o) { return o.id_reservation == dataTemplate.id_reservation }).length
        if (nbResaHeberg > 1) {
            contentMiseEnForme.addClass("texture_grp_resa_" + ((dataTemplate.id_reservation % 10) + 1))
            $("<div style='opacity:0.7;font-size:80%;border-radius:50%;position:absolute;top:-5px;right:5px;background-color:" + theme.backgroundcolorAccent + ";min-width:14px;text-align:center;border:" + theme.border + ";'>" + nbResaHeberg + "</div>").appendTo(contentElement.parent()).attr("title", "<b>" + nbResaHeberg + "</b> hébergement pour cette réservation")
        }

        var dateDeb = dataTemplate.date_debut
        var datFin = dataTemplate.date_fin
        if (dateDeb) {
            var nbNuit = mGetNbNuits(dateDeb, datFin)
            var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yyyy");
            const formatDepart = d => DevExpress.localization.formatDate(d, "dd/MM/yyyy");
            if (dateDeb.getFullYear() == datFin.getFullYear()) {
                if (dateDeb.getMonth() == datFin.getMonth()) {
                    formatArrive = d => DevExpress.localization.formatDate(d, "dd");
                } else {
                    formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM");
                }
            }
            var txt = "" + dateDeb.dayOfWeekName() + " " + formatArrive(dateDeb) + " → " + datFin.dayOfWeekName() + " " + formatDepart(datFin) + " • " + nbNuit + "<i class='fas fa-moon' title='nuités'></i> • "
        }
        if (dataTemplate.nb_adulte > 0) txt += dataTemplate.nb_adulte + "<i class='fas fa-person'></i>"
        if (dataTemplate.nb_enfant > 0) { txt += " " + dataTemplate.nb_enfant + "<i class='fas fa-child-reaching'></i> • " }
        else { txt += " • " }
        if (dataTemplate.lib_client && dataTemplate.lib_client.length > 0) {
            txt += dataTemplate.lib_client + " • "
        } else {
            if (dataTemplate.nom_str && dataTemplate.nom_str.length > 0) txt += dataTemplate.nom_str + " • "
            if (dataTemplate.con_nom && dataTemplate.con_nom.length > 0) txt += dataTemplate.con_nom + " • "
            if (dataTemplate.con_prenom && dataTemplate.con_prenom.length > 0) txt += dataTemplate.con_prenom + " • "
        }

        txt += dataTemplate.keyguid
        txt += "<br/>"
        switch (parseInt(dataTemplate.id_statut_resa)) {
            case 0: txt += "OPTION"; break;
            case 1: txt += "ATTENTE ARRHES"; break;
            case 2: txt += "CONFIRMÉ"; break;
            case 3: txt += "FERMÉ"; break;
            case 4: txt += "ANNULÉ"; break;
            case 5: txt += "<i class='fas fa-cog fa-spin'></i> INTERNET EN COURS"; break;
        }
        txt += " • " + dataTemplate.nom_hebergement
        contentElement.html(txt)

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        var $Span = $("<div style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</div>").appendTo(contentElement)
        $Span.attr("title", "Créé le " + dataPlus.dcr.toFrenchDateTime() + "")
        if (dataPlus.date_debut) {
            var $Span = $("<div style=''><i class='fas fa-arrow-right-long dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.date_debut.toDateIlya(true) + "</div>").appendTo(contentElement)
            $Span.attr("title", "Arrivé le " + dataPlus.date_debut.toFrenchDateTime() + "")
            var $Span = $("<div style=''><i class='fas fa-arrow-left-long dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.date_fin.toDateIlya(true) + "</div>").appendTo(contentElement)
            $Span.attr("title", "Départ le " + dataPlus.date_fin.toFrenchDateTime() + "")
        }
    }

    this.mGetDocCptDetailFromResaHebergResaCmd = function (lstResaHeberg, lstResaCmd, lstArrhes, target, funcOk) {
        if (!lstResaHeberg) lstResaHeberg = this.mGetLstDataReservationHebergement().filter(function (o) { return o.id_reservation_hebergement_parent == null })
        if (!lstResaCmd) lstResaCmd = this.mGetLstReservationCommande()
        //if (mtArrhes == null) mtArrhes = this.mGetTotalArrhesNonUtilise()

        lstResaHeberg = lstResaHeberg.sort(function (o1, o2) { return o1.date_debut - o2.date_debut })
        lstResaCmd = lstResaCmd.sort(function (o1, o2) { return o1.date_service - o2.date_service })

        var lstIdDocCptModeReglement = []
        if (lstArrhes.length > 0) {
            //rajoute les arrhes
            lstArrhes.forEach(function (dataResaArrhes) {
                if (dataResaArrhes.id_doc_cpt_mode_reglement) {
                    //les arrhes ont été réglé
                    lstIdDocCptModeReglement.push(dataResaArrhes.id_doc_cpt_mode_reglement)
                }
            })
        };

        (new cDocCptDetail(Me.objet.bddRef)).mCreateNewDocCpt(Me.objet.bddRef, {
            target: target,
            idTypeCom: 4,
            percentArrhes: 0,
            //docCptModeReglement: docCptModeReglement,
            lst_id_doc_cpt_mode_reglement: lstIdDocCptModeReglement,
            idTableClient: objet.data.id_table_destinataire,
            idClient: objet.data.id_destinataire,
            docCptLigne: mGetLstDataLigne(),
            funcOk: function (docCptDetail) {
                objet.bddRef.mReloadTable(["reservation_hebergement", "reservation_arrhes", "reservation_commande"], function () {
                    funcOk(docCptDetail)
                })
            },
            option_action: {
                lst_resa_heberg: lstResaHeberg,
                //mt_arrhes: mtArrhes,
                lstResaCmd: lstResaCmd
            }
        })

        function mGetLstDataLigne() {
            var lstDataLigne = []
            lstResaHeberg.forEach(function (dataResaHeberg) {
                var objDataResaHeberg = objet.bddRef.getObjet(dataResaHeberg)
                lstDataLigne = lstDataLigne.concat(objDataResaHeberg.objetMetier.mGetGenereLstDocCptLigneReservation())
                lstDataLigne = lstDataLigne.concat(objDataResaHeberg.objetMetier.mGetGenereLstDocCptLigneService())
            })
            lstResaCmd.forEach(function (dataResaCmd) {
                lstDataLigne.push(objet.bddRef.getObjet(dataResaCmd).objetMetier.mGetGenereDocCptLigne())
            })
            return lstDataLigne
        }
    }

    this.mGetLstServiceCommandeArticle = function (dateMin, dateMax) {
        var lstResaHebergActifInDate = objet.bddRef.mGetArray("reservation_hebergement").filter(function (dataResaHeberg) {
            if (dataResaHeberg.date_debut <= dateMax && dataResaHeberg.date_fin >= dateMin) {
                var dataResa = objet.bddRef.getObjet(dataResaHeberg).objetMetier.mGetReservation()
                if (dataResa) {
                    var idStatutResa = dataResa.id_statut_resa
                    if (dataResaHeberg.id_reservation_hebergement_parent != null) {
                        return idStatutResa > 0 && idStatutResa < 3
                    } else {
                        return idStatutResa > 0 && idStatutResa < 4
                    }
                } else {
                    return false
                }
            } else { return false }
        })
        //lstResaHebergActifInDate = $.grep(lstResaHebergActifInDate, function (item) {
        //    var debut = new Date(item.date_debut);
        //    var fin = new Date(item.date_fin);
        //    // chevauchement des périodes
        //    return debut <= dateMax && fin >= dateMin
        //});

        var lstArticle = []
        var lstResaService = []
        lstResaHebergActifInDate.forEach(function (dataResaHeberg) {
            objet.bddRef.getObjet(dataResaHeberg).objetMetier.mGetLstDataReservationService().forEach(function (dataResaHebergService) {
                var lst = objet.bddRef.getObjet(dataResaHebergService).objetMetier.mGetLstDateNbReservationService().filter(function (o) {
                    return o.date >= dateMin && o.date <= dateMax
                })
                if (lst.length > 0) lstResaService = lstResaService.concat(lst)
            })
        })
        var lstResaCommande = objet.bddRef.mGetArray("reservation_commande").filter(function (dataResaCmd) {
            if (lstResaHebergActifInDate.filter(function (dataResaHeberg) { return dataResaHeberg.id_reservation == dataResaCmd.id_reservation }).length > 0) {
                return dataResaCmd.date_service >= dateMin && dataResaCmd.date_service <= dateMax
            } else { return false }
        })

        lstResaService.forEach(function (nbResaService) {
            lstArticle.push({
                key: "service_" + nbResaService.dataReservationService.id_reservation_service,
                id_type_plage_service: nbResaService.dataReservationService.id_type_plage_service,
                id_article: nbResaService.dataReservationService.id_article,
                date: nbResaService.date,
                data: nbResaService,
                qte: nbResaService.mGetQte()
            })
        })
        lstResaCommande.forEach(function (resaCmd) {
            lstArticle.push({
                key: "cmd_" + resaCmd.id_reservation_commande,
                id_type_plage_service: resaCmd.id_type_plage_service,
                id_article: resaCmd.id_article,
                date: resaCmd.date_service,
                data: resaCmd,
                qte: resaCmd.qte
            })
        })
        return lstArticle
    }

    this.mDemandeDisplayNewReservation = function () {
        var dxPopupRight = $("<div/>").appendTo("body").dxCtrlPopupRightTranslate({
            bddCtrl: objet.bddRef,
            width: "500",
            title: "Choisir un hébergement",
            closeOnOutSideClick: true,
            contentTemplate: function (contentElement) {
                $("<div/>").appendTo(contentElement).dxCtrlHebergementSearch({
                    bddCtrl: objet.bddRef,
                    dateVisu: parametre.dateNow,
                    forInternetExterne: false,
                    nb_adulte: 2,
                    nb_enfant: 0,
                    showVacances: true,
                    onSelectHebergement: function (data) {
                        objet.bddRef.getObjet("reservation").objetMetier.mCreateNewReservation(data.idHebergement, data.nb_adulte, data.nb_enfant, data.selectedDates.date_debut, data.selectedDates.date_fin, false, null, true, null, function (data) {
                            objet.bddRef.getObjet(data.dataReservation).mShowPopup({ dataReservationHebergement: data.dataReservationHebergement })
                        })
                        dxPopupRight.mClose()
                    }
                })
            }
        }).dxCtrlPopupRightTranslate("instance")
    }

}